
import Store from '../store/Store'
import StringHelpers from '../helpers/StringHelpers'
import NumberHelpers from './NumberHelpers'
import NiceData from '../data/NiceData'
import DataHelpers from '../helpers/DataHelpers'
import MultiFormat from '../helpers/MultiFormat'


export default class {

    static fetchLoanStructure(transactionKey) {
        return new Promise(async (resolve, reject) => {
        const ref = DataHelpers.getTransactionRef(transactionKey).child('elements')
        const el = await NiceData.fetchItemByName(ref, 'loan_diagram')
            if(!el)
                reject('Loan diagram element not found')    
            resolve(el.diagram)
        })
    }

    static allLoans(structure) {
        let loans = [] 
        structure.forEach(group => {
            loans = [...loans, ...group.loans]
        })
        return loans    
    }

    static loanNewMoney(loan) {
        let amt = loan.newMoney

        if(!amt) {
            amt = loan.amount
            if(loan.lmiType == 'Capitalised')
                amt += loan.lmi
        }
        return amt        
    }

    static loanTotalAmount(loan) {
        let total = loan.amount
        if(loan.lmiType == 'Capitalised')
            total += loan.lmi
        return total   
    }

    static loanSummary(structure) {
        const loans = this.allLoans(structure)
        let summary = {
            newMoney: {title: 'New Money', format: 'Currency', value: 0, id:'newMoney', name:'total_new_money', dashboards: true},
            lmi: {title: 'Mortgage Insurance', format: 'Currency', value: 0, id:'lmi', name:'total_lmi'},
            io: {title: 'Interest Only', format: 'Currency', value: 0, id:'io', name:'total_io'},
            fixed: {title: 'Fixed Rate', format: 'Currency', value: 0, id:'fixed', name:'total_fixed'},
            ownerOccupied: {title: 'Owner Occupied', format: 'Currency', value: 0, id:'ownerOccupied', name:'total_owner_occupied'},
            investment: {title: 'Investment', format: 'Currency', value: 0, id:'investment', name:'total_investment'},
            rateLock: {title: 'Rate Lock', format: 'Currency', value: 0, id:'rateLock', name:'total_rate_lock'},
            special: {title: 'Special', format: 'Currency', value: 0, id:'special', name:'total_special'},
            package: {title: 'Pro Package', format: 'Currency', value: 0, id:'package', name:'total_package'},
            purchaseAddress: {title: 'Purchase Address', format: 'String', value: this.purchaseAddress(structure), id:'purchase_address', name:'purchase_address'},
        }
        loans.forEach(loan => {
            const totalLoan = this.loanTotalAmount(loan)
            summary.newMoney.value += this.loanNewMoney(loan)
            summary.lmi.value += loan.lmi || 0
            summary.io.value += loan.io ? totalLoan : 0
            summary.fixed.value += loan.fixed ? totalLoan : 0
            summary.ownerOccupied.value += !loan.investment ? totalLoan : 0
            summary.investment.value += loan.investment ? totalLoan : 0
            summary.rateLock.value += loan.rateLock ? totalLoan : 0
            summary.special.value += loan.special ? totalLoan : 0
            summary.package.value += loan.package ? totalLoan : 0
        })
        return summary
    }

    static purchaseAddress(structure) {
        return StringHelpers.sentenceJoin(
            this.allProperties(structure)
                .filter(property => !property.existing)
                .map(property => property.address)
        )
    }

    static loanSummaryValue(structure, name) {
        const summary = this.loanSummary(structure)
        const item = summary.find(o => o.name == name)
        if(item)
            return item.value
        else 
            return ''
    }

    static allProperties(structure) {
        let properties = []
        structure.forEach(group => {
            properties = [...properties, ...group.properties]
        })
        return properties
    }

    static diagramDescription(structureEnhanced) {
        let obj = {}
        structureEnhanced.forEach( (group, groupIndex) => {
            if(structureEnhanced.length > 1) {
                obj = MultiFormat.append(obj, `Transaction ${groupIndex + 1}`, {bold:true, underline:true, newline:true})
                obj = MultiFormat.append(obj, '', {newline:true})
            }
            group.loans.forEach((loan, loanIndex) => {
                obj = MultiFormat.append(obj, loan.meta.title, {bold:true, newline:true})
                obj = MultiFormat.append(obj, `- ${loan.meta.description}`)
                // if(loan.product)
                //     obj = MultiFormat.append(obj, ` | ${loan.product}`)
                obj = MultiFormat.append(obj, '', {newline:true})
            })
            obj =  MultiFormat.append(obj, 'Security', {newline:true, bold:true})
            group.properties.forEach( (property, index) => {
                const propertyValue = StringHelpers.formatCurrency(property.value) 
                obj = MultiFormat.append(obj, propertyValue)
                if(property.address) 
                    obj =  MultiFormat.append(obj, ' - ' + property.address)
                const p1 = ' (' + (property.investment ? 'INV' : 'OO') + (property.existing ? '/EXISTING' : '') + ')'
                obj =  MultiFormat.append(obj, p1, {newline:true})
            })
            obj =  MultiFormat.append(obj, '', {newline: true})
        })
        return obj
    }    

    static loanSummaryDescription(structure) {
        let obj = {}
        obj = MultiFormat.append(obj, `Loan Summary`, {bold:true, underline:true, newline:true})
        obj = MultiFormat.append(obj, '', {newline:true})

        let summary = this.loanSummary(structure)
        for(let prop in summary) {
            const item = summary[prop]
            let valueStr = item.value
            if(item.format == 'Currency')
                valueStr = StringHelpers.formatCurrency(valueStr)
            obj = MultiFormat.append(obj, `${item.name}:  `, {bold:true})
            obj = MultiFormat.append(obj, `${valueStr}`, {newline:true})

        }
        return obj
    }

    static loanPayment(loan) {
        if(!loan.amount || !loan.rate)
            return 0
        if(loan.io) {
            return loan.amount * loan.rate / 100 / 12
        }
        if(!loan.years)
            return 0
        return this.monthlyPayment(loan.amount, loan.rate, loan.years)
    }

    static monthlyPayment(balance, rate, years) {
        const ir = rate / 100 / 12
        const np = years * 12
        const pv = 0 - balance
        let fv = 0
        let type = 0

        let pmt, pvif
    
        fv || (fv = 0)
        type || (type = 0)
    
        if (ir === 0)
            return -(pv + fv)/np
    
        pvif = Math.pow(1 + ir, np)
        pmt = - ir * pv * (pvif + fv) / (pvif - 1)
    
        if (type === 1)
            pmt /= (1 + ir)
    
        return pmt
    }

}


// WEBPACK FOOTER //
// ./src/helpers/LoanSecurityHelpers.js